import axios from "axios";
import MockAdapter from 'axios-mock-adapter';

const mock = new MockAdapter(axios);

mock.onGet('/api/lawyer/1').reply(200, {
  data: {
    name: '苏燕仪',
    position: '合伙人律师',
    email: '18665562754@163.com',
    phone: '18665562754',
    address: '广州, 中国',
    introduce: '苏燕仪律师是广东方效律师事务所合伙人律师，毕业于汕头大学,苏燕仪律师自2016年开始执业，擅长争议解决、劳动合规等。曾任广东某知名高中及其附属初中、东北某建筑股份有限公司、佛山市顺德区某房地产投资有限公司、广东某建设有限公司、广州市某实业有限公司等教育机构、企业的法律顾问，对劳动合规、企业合规、纠纷预防等方面提供了有效的帮助。同时，苏燕仪律师执业期间办理了大量的诉讼法律服务，积累了丰富的执业经验，在很多法律服务领域均有所涉猎，熟悉诉讼案件的各阶段程序工作，具有较为丰富的诉讼实战经验，同时也具有扎实的法学理论基础，善于从不同角度分析案件的法律利害关系，为客户提供切实可行的代理方案。',
    photo: 'http://fangxiao.oss-cn-guangzhou.aliyuncs.com/%E8%8B%8F%E7%87%95%E4%BB%AA.jpg3851209381164395222.jpg',
    professionalField: ['民商事诉讼', '劳动争议', '人身损害纠纷', '刑事辩护'],
    cases: '1、代理某银行保理合同纠纷案件，诉讼标的约3000万，案件历经5年，获得胜诉判决。 <br/>2、代理原告东北某建设股份有限公司与被告杨某民间借贷案，通过梳理并正确区分工程承包及民间借贷的法律关系，为原告追回 300 多万借款并顺利执行到位。 <br/>3、 代理被告杨某与原告李某民间借贷纠纷案，判决驳回了原告的全部诉讼请求，通过举证手段及有效的诉讼策略，还原事实真相，维护了被告的合法权益。  <br/>4、代理被告吴某（保证人）与原告陈某民间借贷纠纷案，判决驳回了原告对被告吴某的全部诉讼请求。 <br/>5、代理广州某社会工作服务中心（用人单位）与冯某劳动争议案，劳动仲裁、一审、二审全部胜诉。  <br/>6、代理广州市某工程有限公司（用人单位）与何某等四人劳动关系确认纠纷案，劳动仲裁、一审全部胜诉，驳回劳动者的全部仲裁/诉讼请求。  <br/>7、代理陈某（劳动者）诉广东某建设有限公司劳动争议一审案，劳动仲裁阶段驳回了陈某的全部仲裁请求，律师介入一审后，重新梳理、收集证据，改判支持了劳动者陈某全部的仲裁请求。   <br/>8、代理原告易某等人机动车交通事故责任纠纷一案，通过梳理多种法律关系，追加多名被告，为原告争取到合理赔偿的同时，保障了执行的顺利进行。  <br/>9、代理被告人翟某销售假冒注册商标的商品罪案，公诉人控告翟某犯罪金额高达2665万元，通过合法的取证手段及可行的辩护思路，最后法院认定翟某的犯罪金额为 15 万元。 <br/>10、代理被告人何某走私普通货物罪案，公诉人主张何某为主犯并提出判处无期徒刑的量刑建议，最后法院采纳了辩护人大部分的辩护意见，最后认定何某为起次要作用的从犯，判处有期徒刑 8 年。 <br/>11、代理犯罪嫌疑人东某寻衅滋事罪案，在侦查阶段提出东某属于正当防卫，并积极与办案民警沟通，最终公安机关撤销案件。'
  },
})

mock.onGet('/api/news/1').reply(200, {
  data: {
    picture: 'https://www.fangxiaolaw.cn/img/news-bg.a08ae5df.jpg',
    type: '方效动态',
    title: '方效喜讯 | 方效中标广州市增城区中新镇人民政府法律服务定点采购项目',
    date: '2022-10-24',
    content: '近日，广州市增城区中新镇人民政府法律服务定点采购项目中标结果公布，广东方效律师事务所（以下简称“方效”）成功中标该项目。<br/>近日，广州市增城区中新镇人民政府法律服务定点采购项目中标结果公布，广东方效律师事务所（以下简称“方效”）成功中标该项目。',
  }
})

mock.onGet('/api/job/1').reply(200, {
  data: {
    job: '合伙人律师',
    address: '广州, 中国',
    number: '23',
    professionalField: '不限专业领域',
    jobRequirements: "1、本科毕业于211、985院校或有律师行业经验优先考虑；<br/>2、持有中国法律职业资格证优先；<br/>3、具有扎实的文字功底，写作能力强，能够独立撰写法律相关文书；<br/>4、能够熟练计算机办公软件操作；<br/>5、有较强的法律逻辑思维能力、判断与决策能力、人际沟通及语言表达能力； ",
    workRequirements: "1、协助律师撰写、整理相关诉讼文书并协助出庭；<br/>2、协助律师与客户接洽、商谈等；<br/>3、完成律师交待的其他工作与任务。 ",
    benefits: "1、薪酬:14000-25000元（具体面议）;<br/>2、资深律师指导实习;<br/>3、定期组织专题讲座、业务培训,专业化培养促进成长;<br/>4、经常组织团建、聚餐及下午茶,每年组织国内外旅游;<br/>5、提供全方位的执业后支持。",
  }
})

mock.onGet('/api/jobs').reply(200, {
  data: [
    {
      job: '实习人员',
      address: '广州, 中国',
      date: '2023-10-25',
      number: '10'
    },
    {
      job: '合伙人律师',
      address: '广州, 中国',
      date: '2023-10-25',
      number: '8'
    },
    {
      job: '执业律师',
      address: '广州, 中国',
      date: '2023-10-25',
      number: '20'
    },
    {
      job: '授薪律师',
      address: '广州, 中国',
      date: '2023-10-25',
      number: '30'
    },
  ]
})

mock.onGet('/api/news').reply(200, {
  data: [
    {
      picture: 'https://www.fangxiaolaw.cn/img/news-bg.a08ae5df.jpg',
      type: '方效动态',
      title: '方效喜讯 | 方效中标广州市增城区中新镇人民政府法律服务定点采购项目',
      date: '2022-10-24',
      summary: '近日，广州市增城区中新镇人民政府法律服务定点采购项目中标结果公布，广东方效律师事务所（以下简称“方效”）成功中标该项目。近日，广州市增城区中新镇人民政府法律服务定点采购项目中标结果公布，广东方效律师事务所（以下简称“方效”）成功中标该项目。',
    },
    {
      picture: 'https://www.fangxiaolaw.cn/img/news-bg.a08ae5df.jpg',
      type: '专业研读',
      title: '劳资双方都适合的劳动法新手村攻略',
      date: '2022-10-26',
      summary: '如果单位未按时与员工订立书面劳动合同，但员工入职时签订了入职表或类似的文件，能否代替劳动合同呢？《劳动合同法》第十七条规定了劳动合同应当具备的至少八个条款（在此不予列举）。根据笔者的工作经验，入职表往往难以覆盖该八个必备条款，因此一旦发生纠纷，要素不齐全的入职表能够被劳动仲裁委或者法院认定为劳动合同的可能性很小。从另一个角度讲，如果入职表具备了劳动合同所需的全部条款，那何不干脆直接签订书面劳动合同，以免引起不必要的争议呢？因此，不论是对于劳动者还是用人单位，笔者都不太建议把入职表当成劳动合同，二者在法律上很难相互取代。',
    },
    {
      picture: 'https://www.fangxiaolaw.cn/img/news-bg.a08ae5df.jpg',
      type: '务实解读',
      title: '方效喜讯 | 方效中标广州市增城区中新镇人民政府法律服务定点采购项目',
      date: '2022-10-25',
      summary: '高斌律师现兼任广州仲裁委员会仲裁员、东莞仲裁委员会仲裁员、北海国际仲裁院仲裁员。高斌律师执业期间为多家知名企业、党政机关单位从事专职顾问工作，在公司治理、政府顾问法律服务及相关诉讼领域有着丰富的理论和实践经验，具有丰富的诉讼及非诉讼法律服务经验，在很多法律服务领域均有所涉猎，综合法律服务能力较强，擅长处理合同纠纷、建设工程纠纷、公司纠纷等各类民商事纠纷案件，在公司管理、建设工程、资产融通、债券融资及银行融资等法律服务领域亦有丰富的执业经验及业绩。',
    },
  ]
})

mock.onGet('/api/lawyers').reply(200, {
  data: [
    {
      name: '苏燕仪',
      position: '合伙人律师',
      address: '广州, 中国',
      introduce: '公司法、合同法、刑事诉讼法，执业以来，办理多起疑难复杂案件',
      photo: 'http://fangxiao.oss-cn-guangzhou.aliyuncs.com/%E8%8B%8F%E7%87%95%E4%BB%AA.jpg3851209381164395222.jpg',
    },
    {
      name: '汪满莹',
      position: '律师',
      address: '广州, 中国',
      introduce: '公司法、合同法、刑事诉讼法，执业以来，办理多起疑难复杂案件',
      photo: 'http://fangxiao.oss-cn-guangzhou.aliyuncs.com/%E8%8B%8F%E7%87%95%E4%BB%AA.jpg3851209381164395222.jpg',
    },
    {
      name: '吴白凤',
      position: '执业律师',
      address: '广州, 中国',
      introduce: '公司法、合同法、刑事诉讼法，执业以来，办理多起疑难复杂案件',
      photo: 'http://fangxiao.oss-cn-guangzhou.aliyuncs.com/%E8%8B%8F%E7%87%95%E4%BB%AA.jpg3851209381164395222.jpg',
    }
  ]
})

mock.onGet('/api/professional').reply(200, {
  status: 0,
  data: [
    {
      name: '破产清算',
    },
    {
      name: '劳动争议纠纷',
    },
    {
      name: '民事商纠纷',
    },
    {
      name: '合同纠纷',
    },
    {
      name: '刑事辩护业务',
    },
    {
      name: '行政诉讼业务',
    },
    {
      name: '知识产权业务',
    },
    {
      name: '房地产业务',
    },
    {
      name: '婚姻家庭业务',
    },
  ]
})

mock.onGet('/api/home').reply(200, {
  status: 0,
  data: {
    news: [
      {
        picture: 'https://www.fangxiaolaw.cn/img/news-bg.a08ae5df.jpg',
        type: '方效动态',
        title: '方效喜讯 | 方效中标广州市增城区中新镇人民政府法律服务定点采购项目',
        date: '2022-10-24',
        summary: '近日，广州市增城区中新镇人民政府法律服务定点采购项目中标结果公布，广东方效律师事务所（以下简称“方效”）成功中标该项目。近日，广州市增城区中新镇人民政府法律服务定点采购项目中标结果公布，广东方效律师事务所（以下简称“方效”）成功中标该项目。',
      },
      {
        picture: 'https://www.fangxiaolaw.cn/img/news-bg.a08ae5df.jpg',
        type: '专业研读',
        title: '劳资双方都适合的劳动法新手村攻略',
        date: '2022-10-26',
        summary: '如果单位未按时与员工订立书面劳动合同，但员工入职时签订了入职表或类似的文件，能否代替劳动合同呢？《劳动合同法》第十七条规定了劳动合同应当具备的至少八个条款（在此不予列举）。根据笔者的工作经验，入职表往往难以覆盖该八个必备条款，因此一旦发生纠纷，要素不齐全的入职表能够被劳动仲裁委或者法院认定为劳动合同的可能性很小。从另一个角度讲，如果入职表具备了劳动合同所需的全部条款，那何不干脆直接签订书面劳动合同，以免引起不必要的争议呢？因此，不论是对于劳动者还是用人单位，笔者都不太建议把入职表当成劳动合同，二者在法律上很难相互取代。',
      },
      {
        picture: 'https://www.fangxiaolaw.cn/img/news-bg.a08ae5df.jpg',
        type: '务实解读',
        title: '方效喜讯 | 方效中标广州市增城区中新镇人民政府法律服务定点采购项目',
        date: '2022-10-25',
        summary: '高斌律师现兼任广州仲裁委员会仲裁员、东莞仲裁委员会仲裁员、北海国际仲裁院仲裁员。高斌律师执业期间为多家知名企业、党政机关单位从事专职顾问工作，在公司治理、政府顾问法律服务及相关诉讼领域有着丰富的理论和实践经验，具有丰富的诉讼及非诉讼法律服务经验，在很多法律服务领域均有所涉猎，综合法律服务能力较强，擅长处理合同纠纷、建设工程纠纷、公司纠纷等各类民商事纠纷案件，在公司管理、建设工程、资产融通、债券融资及银行融资等法律服务领域亦有丰富的执业经验及业绩。',
      },
    ],
    lawyers: [
      {
        name: '苏燕仪',
        position: '合伙人律师',
        address: '广州, 中国',
        introduce: '公司法、合同法、刑事诉讼法，执业以来，办理多起疑难复杂案件',
        photo: 'http://fangxiao.oss-cn-guangzhou.aliyuncs.com/%E8%8B%8F%E7%87%95%E4%BB%AA.jpg3851209381164395222.jpg',
      },
      {
        name: '汪满莹',
        position: '律师',
        address: '广州, 中国',
        introduce: '公司法、合同法、刑事诉讼法，执业以来，办理多起疑难复杂案件',
        photo: 'http://fangxiao.oss-cn-guangzhou.aliyuncs.com/%E8%8B%8F%E7%87%95%E4%BB%AA.jpg3851209381164395222.jpg',
      },
      {
        name: '吴白凤',
        position: '执业律师',
        address: '广州, 中国',
        introduce: '公司法、合同法、刑事诉讼法，执业以来，办理多起疑难复杂案件',
        photo: 'http://fangxiao.oss-cn-guangzhou.aliyuncs.com/%E8%8B%8F%E7%87%95%E4%BB%AA.jpg3851209381164395222.jpg',
      }
    ],
    professionalField: [
      {
        name: '破产清算',
      },
      {
        name: '劳动争议纠纷',
      },
      {
        name: '民事商纠纷',
      },
      {
        name: '合同纠纷',
      },
      {
        name: '刑事辩护业务',
      },
      {
        name: '行政诉讼业务',
      },
      {
        name: '知识产权业务',
      },
      {
        name: '房地产业务',
      },
      {
        name: '婚姻家庭业务',
      },
    ]
  }
})